import MarkdownIt from 'markdown-it';

const md = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: false, // We'll handle links manually
});

// Ensure strong/bold rendering works correctly
md.renderer.rules.strong_open = () => '<strong>';
md.renderer.rules.strong_close = () => '</strong>';
md.renderer.rules.em_open = () => '<em>';
md.renderer.rules.em_close = () => '</em>';

// Custom link renderer to ensure target="_blank" and security
md.renderer.rules.link_open = (tokens, idx, options, _env, self) => {
  const token = tokens[idx];
  const href = token.attrGet('href') || '';

  // Validate and format href
  const validHref = href.match(/^https?:\/\//i) ? href : `https://${href}`;

  // Set the href attribute and security attributes
  token.attrSet('href', validHref);
  token.attrSet('target', '_blank');
  token.attrSet('rel', 'noopener noreferrer');
  token.attrSet('class', 'markdown-link');

  return self.renderToken(tokens, idx, options);
};

// Inline variant: no <p> (or any other block) wrapper, for short snippets that are
// already inside a paragraph. Shares the renderer above, so bold, italics, links and
// inline HTML behave identically to the block version.
export function markdownToPreviewInline(markdown: string): string {
  return md.renderInline(markdown);
}

export function markdownToPreview(markdown: string): string {
  let processedText = markdown;

  // Process inline markdown with markdown-it
  processedText = md.render(processedText);

  processedText = processedText.replace(/\n+$/, '');

  return processedText;
}
